module.exports = __webpack_public_path__ + "static/media/jiri-frontend.6c6ec801.png";